import React from 'react';
import styles from './ErrorAlert.module.scss';
import { AlertVariant } from './ErrorAlertContainer';

export default function ErrorIcon({
  variant = 'danger',
}: {
  variant?: AlertVariant;
}) {
  return (
    <i
      className={`icon fas fa-exclamation-triangle fa-lg ${styles['icon']} ${
        variant === 'warning' ? styles['icon-warning'] : ''
      }`}
    ></i>
  );
}
